import { Device, ExtraParameters, OldDevice, System, Systems, Location } from "../models";

export const GENERAL_VIRTUAL_SYSTEM = 'General System';

export const extractVariablesFromDescriptionField = (
  description = '',
): ExtraParameters => {
  const params = description ? description.split('__params__') : [];
  description = params[0];
  if (params.length === 2) {
    return {
      description,
      isInOurCloud: JSON.parse(params[1]).isInOurCloud,
      isEvCharge: JSON.parse(params[1]).isEvCharge,
      isMeter: JSON.parse(params[1]).isMeter,
      systemName: JSON.parse(params[1]).systemName || GENERAL_VIRTUAL_SYSTEM,
      isWithConnext: JSON.parse(params[1]).isWithConnext,
      isConnext: JSON.parse(params[1]).isConnext,
      connextId: JSON.parse(params[1]).connextId,
    };
  }
  return {
    description,
    isInOurCloud: false,
    isEvCharge: false,
    isMeter: false,
    systemName: GENERAL_VIRTUAL_SYSTEM,
    isWithConnext: false,
    isConnext: false,
    connextId: undefined,
  };
};


const addDevice = (devices: Device[], oDevice: OldDevice, extraVariables: ExtraParameters): Device[] => {
  if (!oDevice.thingKey) {
    return devices;
  }
  return [
    ...devices,
    {
      name: oDevice.name || '',
      id: oDevice.thingKey,
      type: extraVariables.isConnext ? 'connext'
        : extraVariables.isEvCharge ? 'evcharge'
        : extraVariables.isMeter ? 'meter'
        : 'inverter',
    },
  ];
};

const addZone = (system: System, oldDevice: OldDevice): Location [] => {
  if (oldDevice.gmtOffset === undefined || oldDevice.coordinate === undefined) {
    return system.configuration.temporaryZoneList;
  }

  return system.configuration
    .temporaryZoneList.find((zone) => zone.coordinates === oldDevice.coordinate)
      ? system.configuration.temporaryZoneList
      : [...system.configuration.temporaryZoneList, {
          tz: oldDevice.gmtOffset,
          coordinates: oldDevice.coordinate,
        }];
};

export const createSystem = (systems: Systems, oldDevice: OldDevice, extraVariables: ExtraParameters): Systems => [
  ...systems,
  {
    name: extraVariables.systemName,
    devices: addDevice([], oldDevice, extraVariables),
    img: '',
    configuration: {
      connextId: extraVariables.connextId || '',
      activeZone: oldDevice.gmtOffset && oldDevice.coordinate ? {
        tz: oldDevice.gmtOffset,
        coordinates: oldDevice.coordinate,
      } : null,
      temporaryZoneList: [],
    },
  },
];

export const updateSystem = (system: System, oldDevice: OldDevice, extraVariables: ExtraParameters): System => ({
  ...system,
  devices: addDevice(system.devices, oldDevice, extraVariables),
  configuration: {
    ...system.configuration,
    temporaryZoneList: addZone(system, oldDevice),
  },
});
